/**
 * ACCOUNT-CS-TYPE-CHIPS
 * All the types of contract in chips (active one colored)
 */
import { useTranslation } from "react-i18next"
import Chip from "@/components/chip"
import { Account, ACCOUNT_CS_TYPES, AccountCsType } from "@/redux/account.types"

interface Props {
  value: AccountCsType | null
  onChange: (csType: AccountCsType | null) => void
}

//Types of contract (and undefined)
const CS_ACCOUNT_TYPES = ACCOUNT_CS_TYPES.map((x) => new Account({ csType: x })).concat([new Account()])

function AccountCsTypeChips(props: Props) {
  const { t } = useTranslation()

  return (
    <div className="flex gap-2">
      {CS_ACCOUNT_TYPES.map((item, i) => (
        <Chip
          key={i}
          icon={item.csTypeIcon}
          onClick={() => props.onChange(item.csType)}
          color={props.value === item.csType ? item.csTypeColor || "#CCCCCC" : null}>
          {t("account_cs_" + item.csType)}
        </Chip>
      ))}
    </div>
  )
}

export default AccountCsTypeChips
